import React from 'react';

interface InlineTextProps extends React.InputHTMLAttributes<HTMLInputElement> {
  minWidth?: number; // in ch units
  className?: string;
  type?: 'text' | 'password' | 'email' | 'url' | 'search' | 'tel';
}

const InlineText = ({
  value,
  minWidth = 1,
  className,
  style,
  placeholder,
  type = 'text',
  ...props
}: InlineTextProps) => {
  let textToMeasure = value;

  if (!value && placeholder) {
    textToMeasure = placeholder;
  }

  const length = typeof textToMeasure === 'string' ? textToMeasure.length : 0;
  const effectiveWidth = Math.max(length, minWidth);

  return (
    <input
      type={type}
      value={value}
      placeholder={placeholder}
      style={{
        background: 'transparent',
        border: '1px dashed #666',
        color: 'inherit',
        fontFamily: 'inherit',
        padding: '0 0.2em',
        display: 'inline-block',
        width: `calc(${effectiveWidth}ch + 0.5em)`,
        transition: 'width 0.1s ease-out',
        ...style,
      }}
      className={className}
      {...props}
    />
  );
};

export default InlineText;